import { MyOrders } from "./components/orders";


function Orders() {

    return (
        <>
            <MyOrders />
        </>
    );
}

export default Orders;